const theme = Object.freeze({
  color: {
    // Purple
    mainPu: '#9935FF',
    hoverPu: '#861DEE',
    pressePu: '#6E0AD1',
    focusPu: '#6E0AD1',
    lightPu1: '#F8F0FF',
    lightPu2: '#ECD9FF',

    // Orange
    textOr: '#FF8832',
    lightOr1: '#FFF0D6',
    lightOr2: '#FFE2AD',

    // Blue
    textBl: '#00A2FE',
    lightBl1: '#E2F5FF',
    lightBl2: '#B1E4FF',

    // Green
    textGn: '#2BA600',
    lightGn1: '#E4FBDC',
    lightGn2: '#D0F5C3',

    // Gray
    lightGr: '#F6F6F6',
    mainGr: '#CCCCCC',
    btnGr: '#555555',
    textGr: '#181818',

    white: '#FFFFFF',
    black: '#000000',
    red: '#DC3A3A',
    surface: '#F6F8FF',
    badgeBg: '#0000008A',
    skeleton: '#e4e4e4',
  },

  border: {
    // Gray
    gr1: '1px solid #CCCCCC',
    gr2: '1px solid #555555',
    gr3: '2px solid #555555',
    gr4: '2px solid #3a3a3a',
    gr5: '1px solid #EEEEEE',

    //Purple
    pu1: '1px solid #9935FF',
    pu2: '1px solid #6E0AD1',
    pu3: '2px solid #9935FF',

    //Red
    rd1: '1px solid #DC3A3A',
  },

  boxShadow: {
    card: '0px 2px 12px 0px rgba(0, 0, 0, 0.08)',
  },

  fontFamily: {
    main: '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
    logo: "'Teko', sans-serif",
  },
  //글씨 사이즈 weight 이어서
});

export default theme;
